class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.handleOnFilterNavigationClick =
      this.handleOnFilterNavigationClick.bind(this);
    this.handleOnFilterElementClick =
      this.handleOnFilterElementClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector("form").addEventListener(
      "input",
      this.debouncedOnSubmit.bind(this)
    );

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

    this.setEventListeners();

    facetFiltersGlobal.push(this);
  }

  setEventListeners() {
    const allFilterElements = Array.from(this.querySelectorAll("details"));

    if (allFilterElements) {
      //       const colors = allFilterElements.find(r => r.querySelector("summary span").textContent.toLowerCase().trim() === "color");

      allFilterElements.forEach((el) => {
        if (el.dataset?.index && !el.dataset?.index?.includes("mobile")) {
          el.firstElementChild.addEventListener("click", (e) =>
            this.handleOnFilterElementClick(e, allFilterElements)
          );

          const sectionToggler = el.querySelector(".facets__section-toggler");
          if (!sectionToggler) return;

          sectionToggler.querySelectorAll("button").forEach((button) => {
            button.addEventListener("click", (e) =>
              this.handleOnFilterNavigationClick(e, allFilterElements)
            );
          });
        }
      });
    }

    let mobileFacetsWrapper = document.querySelector(".mobile-facets__open-wrapper.focus-offset");
    if (mobileFacetsWrapper) {
      mobileFacetsWrapper.addEventListener("click", this.handleOnMobileFilterNavigationClick);
    }
  }

  // on page change
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  // on data update
  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  // on data update
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  // on data update
  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        handleProductQuickView();
      });
  }

  // on data update
  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    handleProductQuickView();
  }

  // on data update
  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
  }

  // on data update
  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  // on data update
  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter"
    );
    // const matchesIndex = (element) => {
    //   const jsFilter = event ? event.target.closest(".js-filter") : undefined;
    //   console.log(jsFilter, 'matchesIndex');
    //   return jsFilter
    //     ? element.dataset.index === jsFilter.dataset.index
    //     : false;
    // };
    // const facetsToRender = Array.from(facetDetailsElements).filter(
    //   (element) => !matchesIndex(element)
    // );
    // const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetDetailsElements.forEach((element) => {
      const el = document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      );
      el.innerHTML = element.innerHTML;

      // console.log(element.dataset.index, 'el');

      // if (!element.className.includes("mobile")) {
      //   const elSummary = el.querySelector("summary");
      //   const elementSummary = element.querySelector("summary");

      //   elSummary.nextElementSibling.innerHTML =
      //     elementSummary.nextElementSibling.innerHTML;
      // } else {
        
      // }
    });

    let mobileFacetsWrapper = document.querySelector(".mobile-facets__open-wrapper.focus-offset");
    if (mobileFacetsWrapper) {
      mobileFacetsWrapper.addEventListener("click", this.handleOnMobileFilterNavigationClick);
    }

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    // if (countsToRender)
    //   FacetFiltersForm.renderCounts(
    //     countsToRender,
    //     event.target.closest(".js-filter")
    //   );

    // facetFiltersGlobal.forEach((g) => {
    //   g.setEventListeners();
    // });

    const facetsList = document.querySelector("facets-list");
    if (facetsList) {
      // facetsList.removeEventListeners();
      facetsList.setEventListeners();
    }
  }

  // on data update
  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  // on data update
  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    let FacetFiltersFormMobile = document.getElementById("FacetFiltersFormMobile");
    if (FacetFiltersFormMobile) {
      FacetFiltersFormMobile.closest("menu-drawer").bindEvents();
    }
  }

  // on data update
  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }
  }

  // on data update
  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      String(
        window.location.pathname + (searchParams && "?".concat(searchParams))
      )
    );
  }

  // on data update
  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  // on filter click (inside drawer)
  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest("form"));
    const searchParams = new URLSearchParams(formData).toString();

    FacetFiltersForm.renderPage(searchParams, event);
  }

  // on reset click (inside drawer)
  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    FacetFiltersForm.renderPage(
      new URL(event.currentTarget.href).searchParams.toString()
    );
  }

  // filter navigation buttons inside drawer
  handleOnFilterNavigationClick(e, allFilterElements) {
    if (e) e.preventDefault();

    const target = e.currentTarget;
    const dataTarget = target.dataset.target;
    const currentParent = target.parentElement.parentElement.parentElement;
    let currentIndex = Number(currentParent.dataset.index);

    let parentClassName;
    let currentClassName;

    if (dataTarget === "filter-right-navigation") {
      if (currentIndex < allFilterElements.length) currentIndex += 1;
      else currentIndex = 1;
      parentClassName = "facets__slide-from-right";
      currentClassName = "facets__close-from-right";
    } else if (dataTarget === "filter-left-navigation") {
      if (currentIndex > 1) currentIndex -= 1;
      else currentIndex = allFilterElements.length;
      parentClassName = "facets__slide-from-left";
      currentClassName = "facets__close-from-left";
    }

    let parentToDisplay = this.findFilterElement(
      allFilterElements,
      (current) => currentIndex === Number(current.dataset.index)
    );
    if (!parentToDisplay) return;

    const currentParentDisplayPanel =
      currentParent.querySelector(".facets__display");
    const parentToDisplayDisplayPanel =
      parentToDisplay.querySelector(".facets__display");

    currentParentDisplayPanel.classList.add(currentClassName);
    setTimeout(() => {
      currentParentDisplayPanel.classList.remove(currentClassName);
      currentParent.removeAttribute("open");
    }, 200);

    parentToDisplay.setAttribute("open", true);
    parentToDisplayDisplayPanel.classList.add(parentClassName);
    setTimeout(() => {
      parentToDisplayDisplayPanel.classList.remove(parentClassName);
    }, 200);
  }

  handleOnMobileFilterNavigationClick() {
    let parent = document.getElementById("main-collection-filters");
    if (!parent)
      parent = document.getElementById("search-main-collection-filters");
    if (!parent) return;
    const isOpen = parent
      .querySelector("menu-drawer")
      .firstElementChild.hasAttribute("open");

    parent.style.zIndex = isOpen ? 1 : 10;
  }

  handleOnFilterElementClick(e, allFilterElements) {
    let facetsOverlay = document.getElementById("facets-overlay");
    let parent = document.getElementById("main-collection-filters");
    if (!parent)
      parent = document.getElementById("search-main-collection-filters");
    if (!parent) return;

    if (!facetsOverlay) {
      parent.style.zIndex = 10;
      facetsOverlay = document.createElement("div");
      facetsOverlay.id = "facets-overlay";
      facetsOverlay.style.cssText =
        "position: fixed; top: 0; left: 0; z-index: 3; background: #14141477; height: 100vh; width: 100vw; display: block;";
      facetsOverlay.onclick = () => {
        facetsOverlay.remove();
        facetsOverlay = undefined;
        parent.style.zIndex = 3;
        this.findFilterElement(allFilterElements, (current) =>
          current.hasAttribute("open")
        )?.removeAttribute("open");
      };
    }

    const displayPanel = e.currentTarget.nextElementSibling;
    displayPanel.classList.add("facets__slide-from-left");
    setTimeout(
      () => displayPanel.classList.remove("facets__slide-from-left"),
      200
    );

    document.querySelector(".facets-container").prepend(facetsOverlay);
  }

  findFilterElement = (allFilterElements, condition) => {
    let value = null;

    for (let i = 0; i < allFilterElements.length; i++) {
      const filterElement = allFilterElements[i];

      if (condition(filterElement)) {
        value = filterElement;
        break;
      }
    }

    return value;
  };
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector("a").addEventListener("click", (event) => {
      event.preventDefault();
      const form =
        this.closest("facet-filters-form") ||
        document.querySelector("facet-filters-form");
      form.onActiveFilterClick(event);
    });
  }
}
customElements.define("facet-remove", FacetRemove);

class FacetRemoveV2 extends HTMLElement {
  constructor() {
    super();
    this.querySelector("a").addEventListener("click", (event) => {
      event.preventDefault();
      const form = document.querySelector("#facet-filters-form");
      form.onActiveFilterClick(event);
      CloseFacetsDrawer();
    });
  }
}

customElements.define("facet-remove-v2", FacetRemoveV2);

class FacetsList extends HTMLElement {
  constructor() {
    super();
    this.lists = this.querySelectorAll(".facets__lists_item");
    this.setEventListeners();
  }

  setEventListeners() {
    this.lists.forEach((list) => {
      list.querySelector("h4").addEventListener("click", (event) => {
        if (list.classList.contains("active")) {
          list.classList.remove("active");
        } else {
          this.closeAllItems();
          list.classList.add("active");
        }
      });
    });
  }

  removeEventListeners() {
    this.lists.forEach((list) => {
      list.querySelector("h4").removeEventListener("click", (event) => {
        if (list.classList.contains("active")) {
          list.classList.remove("active");
        } else {
          this.closeAllItems();
          list.classList.add("active");
        }
      });
    });
  }

  openItem(label) {
    this.lists.forEach((list) => {
      if (list.dataset.label.toLowerCase() === label.toLowerCase()) {
        this.closeAllItems();
        if (!list.classList.contains("active")) {
          list.classList.add("active");
        }
      }
    });
  }

  closeAllItems() {
    this.lists.forEach((list) => {
      if (list.classList.contains("active")) {
        list.classList.remove("active");
      }
    });
  }
}
customElements.define("facets-list", FacetsList);

class FacetsDrawerV2 extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("click", this.outSideClick.bind(this));
    this.facetsWrapperDesktopV2 = document.querySelector("#FacetsWrapperDesktopV2");
    this.facetsWrapperContainer = document.querySelector(".facets-container--v2");
    this.toggleBtn = document.querySelector('#collection-filtter--btn');
    this.closeDrawerBtn = this.querySelector("#facets_drawer_close");

    if (this.facetsWrapperDesktopV2) {
      this.labelItems = this.facetsWrapperDesktopV2.querySelectorAll(".facets__title");
      this.labelItems.forEach((item) => {
        item.addEventListener("click", (event) => {
          this.openFacetsDrawer();
          let currentLabel = item.getAttribute("data-label");
          const facetsList = document.querySelector("facets-list");
          if (facetsList) {
            facetsList.openItem(currentLabel);
          }
        });
      });
    }

    this.toggleBtn.addEventListener("click", this.openFacetsDrawer.bind(this));
    this.closeDrawerBtn.addEventListener("click", this.closeFacetsDrawer.bind(this));
    document.addEventListener("keyup", this.onKeyUp.bind(this));
  }

  outSideClick(event) {
    let element = event.target;
    if (
      this.toggleBtn.contains(element) === false && 
      this.facetsWrapperContainer.classList.contains("open") === true &&
      this.facetsWrapperDesktopV2.contains(element) === false &&
      this.contains(element) === false
    ) {
      this.closeFacetsDrawer();
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    if (this.facetsWrapperContainer.classList.contains("open") === true) {
      this.closeFacetsDrawer();
    }
  }

  openFacetsDrawer() {
    if (this.facetsWrapperContainer) {
      let html = `<div id="facets-overlay" style="position: fixed; top: 0px; left: 0px; z-index: 10; background: rgba(20, 20, 20, 0.467); height: 100vh; width: 100vw; display: block;"></div>`;
      this.facetsWrapperContainer.insertAdjacentHTML('afterbegin', html);
      this.facetsWrapperContainer.classList.add("open");
    }
  }

  closeFacetsDrawer(event) {
    let html = this.facetsWrapperContainer.querySelector("#facets-overlay");
    if (html) html.remove();
    this.facetsWrapperContainer.classList.remove("open");
  }
}
customElements.define("facets-drawer-v2", FacetsDrawerV2);
